import Box from '@mui/material/Box';
import ProductForm from '../FormsView/ProductForm/index';

export const FormCategoryPage = () => {
  return (
    <Box sx={{ background: 'white' }}>
      <ProductForm />
    </Box>
  );
};

export default FormCategoryPage;
